import { useState } from "react";
import { Menu, X } from "lucide-react";

function NavbarDWP() {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    "Home",
    "About",
    "Courses",
    "Benefits",
    "Contact",
  ];

  return (
    <nav className="fixed top-0 left-0 w-full bg-white/90 backdrop-blur-md shadow-md z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">

          {/* Logo */}
          <div className="flex items-center gap-3">
            <img
              src="/DWP2.jpeg"
              alt="Digital with Priyanshi"
              className="w-12 h-12 rounded-full object-cover"
            />

            <div>
              <h1 className="text-xl font-bold text-blue-700">
                Digital with Priyanshi
              </h1>
              <p className="text-xs text-gray-500">
                Learn. Create. Innovate.
              </p>
            </div>
          </div>

          {/* Desktop Menu */}
          <ul className="hidden lg:flex items-center gap-8">
            {navLinks.map((item) => (
              <li key={item}>
                <a
                  href={`#${item.toLowerCase()}`}
                  className="font-medium text-gray-700 hover:text-blue-700 transition"
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop Button */}
          <button className="hidden lg:block bg-blue-700 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-800 transition duration-300">
            Enroll Now
          </button>

          {/* Mobile Icon */}
          <button
            className="lg:hidden"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <X size={30} className="text-blue-700" />
            ) : (
              <Menu size={30} className="text-blue-700" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <ul className="flex flex-col items-center gap-6 py-6">
            {navLinks.map((item) => (
              <li key={item}>
                <a
                  href={`#${item.toLowerCase()}`}
                  className="text-gray-700 font-medium hover:text-blue-700"
                  onClick={() => setIsOpen(false)}
                >
                  {item}
                </a>
              </li>
            ))}

            <button className="bg-blue-700 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-800 transition">
              Enroll Now
            </button>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default NavbarDWP;